export class ReferralsUtil {

  public static generateLink = (link: string, query: Object) => {
    if (Object.keys(query).length) {
      let index = 0;
      link += '?';
      for (const [key, value] of Object.entries(query)) {
        link += `${key}=${value}`;
        index++;
        if (index !== Object.keys(query).length) {
          link += '&';
        }
      }
    }
    return link;
  };
}
